import { useNavigate } from "react-router-dom";

const SOURCES = [
  { key: "tiktok", label: "TikTok", icon: "🎵" },
  { key: "instagram", label: "Instagram", icon: "📸" },
  { key: "twitter", label: "Twitter / X", icon: "🐦" },
  { key: "friend", label: "A friend told me", icon: "💬" },
  { key: "search", label: "Google / Search", icon: "🔍" },
  { key: "other", label: "Other", icon: "✨" },
];

export function OnboardingHowYouHeardPage() {
  const navigate = useNavigate();

  const handleSelect = (_source: string) => {
    // Analytics: PostHog event would go here
    navigate("/onboarding/usage-intent");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #fdf2f2 0%, #ffffff 100%)",
        padding: "24px",
      }}
    >
      <div style={{ maxWidth: "360px", width: "100%", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "1.5rem",
            fontWeight: 800,
            color: "#171717",
            marginBottom: "8px",
          }}
        >
          How did you hear about Stalkie?
        </h1>
        <p style={{ color: "#737373", marginBottom: "32px", fontSize: "0.9375rem" }}>
          Help us understand where our users come from.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {SOURCES.map((source) => (
            <button
              key={source.key}
              onClick={() => handleSelect(source.key)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "14px 16px",
                background: "white",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                borderRadius: "14px",
                cursor: "pointer",
                textAlign: "left",
                fontSize: "0.9375rem",
                fontWeight: 600,
                color: "#171717",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "#ff6b8a";
                (e.currentTarget as HTMLButtonElement).style.background = "#fdf2f2";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "rgba(15, 23, 42, 0.08)";
                (e.currentTarget as HTMLButtonElement).style.background = "white";
              }}
            >
              <span style={{ fontSize: "24px" }}>{source.icon}</span>
              {source.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
